module.exports = __webpack_public_path__ + "static/media/disney.ce0010d8.png";